import useSEO from '@/hooks/useSEO';
import { costFAQs } from './components/CostFAQSection';
import HeroSection from './components/HeroSection';
import CostDeepDiveSection from './components/CostDeepDiveSection';
import InteractiveCostCalculator from './components/InteractiveCostCalculator';
import TradingStyleSection from './components/TradingStyleSection';
import SessionMonitorSection from './components/SessionMonitorSection';
import RealTradeExamples from './components/RealTradeExamples';
import CostFAQSection from './components/CostFAQSection';
import FeaturedBrokersGrid from '@/components/feature/FeaturedBrokersGrid';

function buildFAQAnswer(faq: typeof costFAQs[number]): string {
  const parts = [faq.answer.main];
  if (faq.answer.example) {
    parts.push(`${faq.answer.example.label}: ${faq.answer.example.text}`);
  }
  if (faq.answer.tip) {
    parts.push(`Tip: ${faq.answer.tip}`);
  }
  return parts.join(' ');
}

export default function Home() {
  useSEO({
    /* @replace:home-title */

    title: 'Forex Trading Costs: Spread, Commission, Swap and Slippage',
    /* @replace:home-description */

    description: 'Understand the real cost of forex trading, including spread, commission, swap, slippage and hidden fees, with clear formulas, examples and a calculator.',
    /* @replace:home-keywords */

    keywords: 'forex trading costs, forex fees, forex spread, forex commission, forex swap, forex slippage, forex cost calculator',
    /* @replace:home-canonical */

    canonical: '/',
  });

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: costFAQs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: buildFAQAnswer(faq),
      },
    })),
  };

  return (
    <div className="min-h-screen">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />
      <HeroSection />
      <CostDeepDiveSection />
      <InteractiveCostCalculator />
      <TradingStyleSection />
      <SessionMonitorSection />
      <RealTradeExamples />
      <FeaturedBrokersGrid />
      <CostFAQSection />
    </div>
  );
}